import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Loader2 } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const { signIn } = useAuth();
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    try {
      const result = await signIn(email);
      
      if (result.error) {
        throw result.error;
      }

      toast({
        title: "¡Acceso concedido!",
        description: "Bienvenido de nuevo.",
      });

      if (result.onboarding_completed) {
        navigate('/app');
      } else {
        navigate('/onboarding');
      }

    } catch (err: any) {
      console.error("Login error:", err);
      toast({
        title: "Error al acceder",
        description: err.message === 'No access found' || err.message === 'No autorizado' || err.message === 'Access denied'
          ? "No encontramos un acceso activo con este correo. Usa el mismo correo de tu compra." 
          : "Verifica tu información e intenta nuevamente.",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="w-full max-w-sm animate-fade-in bg-card p-8 rounded-2xl shadow-sm border border-border">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-heading font-bold text-primary mb-2">Accede a tu método</h1>
          <p className="text-sm text-muted-foreground">Ingresa el correo de tu compra para entrar</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="email">Tu correo electrónico</Label>
            <Input
              id="email"
              type="email"
              placeholder="El correo de tu compra..."
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="rounded-xl h-12"
            />
            <p className="text-xs text-muted-foreground pt-1 text-center">
              * Usa el mismo correo con el que realizaste tu compra
            </p>
          </div>
          <Button type="submit" className="w-full h-12" size="lg" disabled={loading}>
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : 'Entrar ahora'}
          </Button>
        </form>

      </div>
    </div>
  );
};

export default Login;